// Turning the variants table's typed prices into API updates (POS comments item 3).
//
// Each variant stores its own price (OD5), so a typed selling price is sent as
// `price`. Only changed rows are sent.

import type { CurrencyCode } from '@bbpos/types';
import { rupeeInputToPaise } from '@/utils/price-input';

export interface VariantPriceEdit {
  price?: string;
  cost?: string;
}

export interface VariantPriceUpdate {
  id: string;
  price?: number;
  cost?: number;
}

interface VariantPricing {
  id: string;
  price?: number | null;
  cost?: number | null;
}

export function variantPriceChanges(
  variants: VariantPricing[],
  edits: Record<string, VariantPriceEdit>,
  currency: CurrencyCode,
): { updates: VariantPriceUpdate[]; errors: Array<{ id: string; message: string }> } {
  const updates: VariantPriceUpdate[] = [];
  const errors: Array<{ id: string; message: string }> = [];
  for (const v of variants) {
    const e = edits[v.id];
    if (!e) continue;
    const update: VariantPriceUpdate = { id: v.id };
    if (e.price !== undefined) {
      const price = rupeeInputToPaise(e.price, currency);
      if (price === null || price < 0) {
        errors.push({ id: v.id, message: 'Enter a valid price' });
        continue;
      }
      if (price !== Number(v.price ?? 0)) update.price = price;
    }
    if (e.cost !== undefined) {
      const cost = rupeeInputToPaise(e.cost, currency);
      if (cost === null || cost < 0) {
        errors.push({ id: v.id, message: 'Enter a valid cost' });
        continue;
      }
      if (cost !== Number(v.cost ?? 0)) update.cost = cost;
    }
    if (update.price !== undefined || update.cost !== undefined) updates.push(update);
  }
  return { updates, errors };
}
